import React from "react";
import CourseLockedBottomSheet from "../CourseLockedBottomSheet/CourseLockedBottomSheet";
import { useDispatch, useSelector } from "react-redux";
import * as actionCreator from "../../store/actions";
import { getAwsAssets } from "@src/utils";
import { useTranslation } from "react-i18next";
import { initialisePaymentService } from "@src/PaymentService";
import { getLockedContentText } from "@src/utils";
import { safeJsonParse } from "@src/utils/safeJsonParse";
import toast from "react-hot-toast";
import { courseFacultyListAction } from "../../../Tabs/Overview/store/actions";
import styles from "./ContentLockedBottomSheet.module.scss"
import { enrollOnFreeCourse } from "@src/PaymentService/enrollForFreeCourse";
const ContentLockedBottomSheet = () => {
  const { t } = useTranslation();

  const state = useSelector(
    (state) => state?.bottomSheetReducer?.showContentLockedBottomSheet
  );

  const purchaseViaWhatsappV2 = useSelector(
    (state) =>
      state?.overviewReducer?.overViewDetails?.course?.purchaseViaWhatsappV2
  );

  const purchaseViaWhatsapp = useSelector(
    (state) =>
      state?.overviewReducer?.overViewDetails?.course?.purchaseViaWhatsapp
  );

  const orgId = useSelector((state) => state?.overviewReducer?.overViewDetails?.course
  ?.metaData?.orgId)

  const item = safeJsonParse(localStorage.getItem("currentItem"), {
    source: "ContentLockedBottomSheet [localStorage.currentItem]",
    fallback: {},
  });
  let scheduledFromDate = item?.scheduledFromDate;
  let scheduledToDate = item?.scheduledToDate;
  let isPurchased = item?.isPurchased;
  let isScheduled = item?.isScheduled;
  let isLocked = item?.isLocked;

  // let showBtn = isScheduled || (!isPurchased && isLocked) ? 1 : 0;
  let showBtn = isPurchased ? 0 : isLocked;

  console.log(showBtn, "showBtn", isScheduled || (!isPurchased && isLocked));
  const dispatch = useDispatch();

  const isComboActive = useSelector(
    (state) =>
      state?.overviewReducer?.overViewDetails?.course?.metaData?.isComboActive
  );

  const courseId = useSelector(
    (state) => state?.overviewReducer?.overViewDetails?.course?.metaData?.id
  );

   const isIdfysVerificationRequired = useSelector(
    (state) => state?.overviewReducer?.overViewDetails?.course?.metaData?.verificationDetails?.prePurchase?.isVerificationRequired
  ) || false;
  const isPaymentFailed = useSelector((state) => state.bottomSheetReducer?.isIdysPaymentRejected)
  let autopayConfig = useSelector(
    (state) =>
       state?.overviewReducer?.overViewDetails?.course?.metaData?.autopayConfig || state?.overviewReducer?.graphCourseData?.autopayConfig
  );

  const isAutoPayEnabled = useSelector(
    (state) =>
      state?.overviewReducer?.overViewDetails?.course?.metaData?.isAutoPayEnabled || 0 
  );
  autopayConfig = { ...(autopayConfig?.trialData ? autopayConfig?.trialData : autopayConfig), isAutoPayEnabled }

  const getTrialUnit = () => {
    if(autopayConfig?.trialUnit==1){
      return autopayConfig?.trialPeriod == 1 ? 'day' : 'days'
    } else if(autopayConfig?.trialUnit==2){
      return autopayConfig?.trialPeriod == 1 ? 'month' : 'months'
    } else if(autopayConfig?.trialUnit==3){
      return autopayConfig?.trialPeriod == 1 ? 'year' : 'years'
    } else {
      return ''
    }
  }

  const isFreeCourse = useSelector(
    (state) =>
      state?.overviewReducer?.overViewDetails?.course?.metaData?.isFreeCourse
  ) || 0;

  let customClasses = {
    btnText: '',
    viewAllSubText: '',
    parentContainer: ''
  };

  if(isFreeCourse){
    customClasses = {
      btnText: styles.FreeCourse__btnText,
      viewAllSubText: styles.FreeCourse__backBtn,
      parentContainer: styles.FreeCourse__wrapper
    };
  }
  return (
    <CourseLockedBottomSheet
      mainText={t(
        "components.bottomSheets.components.contentLockedBottomSheet.contentIsLocked",
        "Your Content is Locked"
      )}
      subText={getLockedContentText(
        scheduledFromDate,
        scheduledToDate,
        isPurchased,
        isScheduled,
        isLocked
      )}
      btnText={isFreeCourse ? "Get this course for free" :
        (autopayConfig && isAutoPayEnabled && autopayConfig.trialPeriod && autopayConfig.trialAmountInRs)
              ? `Start ${autopayConfig.trialPeriod} ${getTrialUnit()} Trial at ₹${autopayConfig.trialAmountInRs}` :
         (purchaseViaWhatsapp || purchaseViaWhatsappV2 === 1 )? "I'm interested" : t(
        "components.bottomSheets.components.contentLockedBottomSheet.buyNow",
        "Buy now"
      )}
      btnAction={() => {
        let deviceInfo = safeJsonParse(window?.androidData, {
          source: "ContentLockedBottomSheet [window.androidData]",
          fallback: null,
        });
        let version = deviceInfo?.deviceInfo?.sdk
        if (version && version < 24 && (orgId == 573212 || orgId == 170)) {
          return dispatch(actionCreator.setNotSupportedBottomsheet(true));
        }
        if(isFreeCourse){
          enrollOnFreeCourse(courseId)
          dispatch(actionCreator.showContentLockedBottomSheetAction(false));
        } else if (isComboActive) {
          dispatch(actionCreator.courseFacultyListModalAction(true));
          dispatch(actionCreator.showContentLockedBottomSheetAction(false));
        } else {
          dispatch(actionCreator.showContentLockedBottomSheetAction(false));
          if(isIdfysVerificationRequired && !isPaymentFailed) {
            dispatch(actionCreator.idfysContentLockAction(true));
          } else {
             initialisePaymentService();
          }
        }
      }}
      viewAllSubText={
        showBtn
          ? t(
              "components.bottomSheets.components.contentLockedBottomSheet.goBackInstead",
              "Go back instead"
            )
          : t(
              "components.bottomSheets.components.contentLockedBottomSheet.goBack",
              "Go back"
            )
      }
      state={state}
      dispatcher={() => {
        if (isComboActive) {
          return;
        } else {
          dispatch(actionCreator.showContentLockedBottomSheetAction(false));
        }
      }}
      showBtn={showBtn}
      isCloseButtonVisible={!isFreeCourse}
      customClasses={customClasses}
      iconColor={isFreeCourse ? "#5A5CD4" : ""}
    />
  );
};

export default ContentLockedBottomSheet;
